import { render, staticRenderFns } from "./Methodology.vue?vue&type=template&id=4621128d&"
import script from "./Methodology.vue?vue&type=script&lang=js&"
export * from "./Methodology.vue?vue&type=script&lang=js&"
import style0 from "./Methodology.vue?vue&type=style&index=0&id=4621128d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports